var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEditor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 11.75C2.82436 11.75 0.25 9.17564 0.25 6C0.25 2.82436 2.82436 0.25 6 0.25C9.17564 0.25 11.75 2.82436 11.75 6C11.75 9.17564 9.17564 11.75 6 11.75Z",
    fill: "#B3BCD2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.16818 3.35046C6.24667 3.27479 6.37131 3.27593 6.4484 3.35303L8.57574 5.48036C8.65486 5.55948 8.65368 5.68812 8.57312 5.76577L5.26872 8.95115C5.23145 8.98708 5.18169 9.00716 5.12992 9.00716H3.0004C2.88994 9.00716 2.8004 8.91762 2.8004 8.80716V6.68193C2.8004 6.62762 2.82249 6.57564 2.86159 6.53794L6.16818 3.35046ZM6.44758 4.57845C6.37081 4.50169 6.24682 4.50018 6.16821 4.57506L3.70815 6.91839C3.66852 6.95613 3.64609 7.00847 3.64609 7.0632V7.96147C3.64609 8.07192 3.73563 8.16147 3.84609 8.16147H4.75005C4.80141 8.16147 4.8508 8.14171 4.88799 8.10628L7.34514 5.76573C7.4265 5.68824 7.42807 5.55895 7.34862 5.4795L6.44758 4.57845ZM7.48989 2.13464C7.56908 2.05986 7.69355 2.06219 7.76988 2.13988L9.86147 4.26881C9.93839 4.34711 9.93784 4.47278 9.86022 4.5504L9.42298 4.98764C9.34487 5.06575 9.21824 5.06575 9.14014 4.98764L7.01685 2.86436C6.93716 2.78467 6.93902 2.65491 7.02095 2.57753L7.48989 2.13464Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditor);
export default __webpack_public_path__ + "static/media/editor.708a940d465183925ad5069ad75bc905.svg";
export { ForwardRef as ReactComponent };